import PropTypes from 'prop-types'
import { SkeletonMaskContainer } from './styled-component'

const SkeletonComponent = ({
  children,
  isLoading,
  skeletonShape,
  elementQuantity = 1
}) => {
  if (isLoading)
    return Array.from({ length: elementQuantity }, (_, index) => (
      <SkeletonMaskContainer key={index} skeletonShape={skeletonShape} />
    ))

  return children
}

SkeletonComponent.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  skeletonShape: PropTypes.object
}

export default SkeletonComponent
